import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Shirt = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="shirt icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 22"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5 0.000244141C8.5 0.000244141 9.5 2 12 2C14.5 2 15.5 0.000244141 15.5 0.000244141C15.5 0.000244141 17.9852 0.937335 18.8847 1.39921C19.4749 1.70229 20.0521 2.03476 20.5354 2.37759C21.0073 2.71237 21.4365 3.08925 21.6787 3.493C22.0777 4.15793 22.6548 5.50951 23.1196 6.65614C23.3553 7.23756 23.5673 7.77932 23.7203 8.1756C23.7969 8.37381 23.8587 8.5358 23.9015 8.64835C23.9229 8.70464 23.9395 8.74857 23.9508 8.7785L23.9678 8.82384C23.9678 8.82384 23.9682 8.82468 23.5 9.00024L23.9678 8.82384C24.0165 8.95347 24.0095 9.0983 23.948 9.22235C23.8865 9.34639 23.7763 9.43937 23.6437 9.47916L20.5354 11.5001L19 7.97916V20.0001C19 21.0001 15.6468 21.9763 12.5 22.0001C9.02071 22.0265 5 21.0001 5 20.0001V7.97916L3.52522 11.5001L0.356326 9.47916C0.223716 9.43937 0.113537 9.34639 0.0520372 9.22235C-0.00946254 9.0983 -0.0167772 8.95432 0.0318357 8.82468L0.5 9.00024C0.0318357 8.82468 0.0318357 8.82468 0.0318357 8.82468L0.0492222 8.7785C0.0605175 8.74857 0.077131 8.70464 0.0985129 8.64835C0.141274 8.5358 0.203123 8.37381 0.27966 8.1756C0.432679 7.77932 0.644671 7.23756 0.880381 6.65614C1.34523 5.50951 1.9223 4.15793 2.32125 3.493C2.57766 3.06566 3.03037 2.67211 3.52522 2.32616C4.03123 1.97241 4.63081 1.63492 5.23324 1.33238C6.1049 0.894634 8.5 0.000244141 8.5 0.000244141Z"
    />
  </svg>
)
